module.exports = __webpack_public_path__ + "static/media/home-bg-mobile.393d9f8a.webp";